import React from 'react';

export const ButtonOrLink = ({ type = 'button', children, ...rest }) =>
  React.createElement(type, { ...rest }, children);
